import CityPageTemplate from "../city-template/CityPageTemplate";
import { postFallsConfig } from "./data";

export default function PostFallsPage() {
  return <CityPageTemplate config={postFallsConfig} />;
}